<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card class="list-view-item overflow-hidden" v-on="$listeners">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">

                <!-- IMG COL -->
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer" @click="navigate_to_detail_view">
                    <!-- <img :src="item.image" :alt="item.nomart" class="grid-view-img p-4"> -->
                    <img :src="item.imagen?('data:image/png;base64,'+item.imagen+''):defaultImageURL" :alt="item.nomart" class="grid-view-img ">
                </div>

                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-1/2">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.nomart }}</h6>
                            <!-- <p class="text-sm mb-4">Por <span class="font-semibold cursor-pointer">{{ item.brand }}</span></p> -->
                            <p class="item-description text-sm">Código: {{ item.codart }}</p>
                            <p v-if="item.deta01" class="item-description text-sm"> {{ item.deta01 }}</p>
                            <p v-if="item.deta02" class="item-description text-sm"> {{ item.deta02 }}</p>
                            <p v-if="item.deta03" class="item-description text-sm"> {{ item.deta03 }}</p>
                            <p v-if="item.deta04" class="item-description text-sm"> {{ item.deta04 }}</p>
                            <p v-if="item.deta05" class="item-description text-sm"> {{ item.deta05 }}</p>
                            <p v-if="item.deta06" class="item-description text-sm"> {{ item.deta06 }}</p>
                            <p v-if="item.deta07" class="item-description text-sm"> {{ item.deta07 }}</p>
                            <p v-if="item.deta08" class="item-description text-sm"> {{ item.deta08 }}</p>
                            <p v-if="item.deta09" class="item-description text-sm"> {{ item.deta09 }}</p>
                            <p v-if="item.deta10" class="item-description text-sm"> {{ item.deta10 }}</p>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

                    <div class="p-4 flex flex-col w-full">


                        <div class="my-6">
                            <div class="justify-content-center text-primary border border-solid border-primary flex py-1 px-2 rounded">
                                <h5 class="font-bold text-center text-primary">${{ lispreShow () }}</h5>
                            </div>
                            <span class="text-grey flex items-start justify-center mt-1" v-if="item.free_shipping">
                                <feather-icon icon="ShoppingCartIcon" svgClasses="w-4 h-4" />
                                <!-- <span class="text-sm ml-2">Free Shipping</span> -->
                            </span>
                        </div>

                        <!-- SLOT: ACTION BUTTONS -->
                        <slot name="action-buttons" />
                    </div>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
import {mapState} from 'vuex'

export default{
  data () {
    return {
        defaultImageURL: require('@/assets/images/elements/not-available-es.png')
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('eCommerce',['lispreState']),
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    }
  },
  methods: {
    lispreShow (){
        var lis = this.lispreState;
        if(lis.toString() === '1'){
            return this.item.prec01
        }else if (lis.toString() === '2'){
            return this.item.prec02
        }else if(lis.toString() === '3'){
            return this.item.prec03
        }else if (lis.toString() === '4'){
            return this.item.prec04
        }else{
            return this.item.prec01
        }
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    cartButtonClicked (item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {}) : this.additemInCart(item)
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'ecommerce-item-detail-view', params: {item_id: this.item.objectID }})
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: -webkit-fill-available;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
